import { render } from "./TngHeader.vue?vue&type=template&id=8db055f4&scoped=true&ts=true"
import script from "./TngHeader.vue?vue&type=script&lang=ts"
export * from "./TngHeader.vue?vue&type=script&lang=ts"

import "./TngHeader.vue?vue&type=style&index=0&id=8db055f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8db055f4"]])

export default __exports__